<template>
  <div>
    <vue-apex-charts
      :options="chartOptions"
      :series="series"
      @dataPointSelection="emitClickSection"
      :height="height"
    ></vue-apex-charts>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    VueApexCharts
  },
  props: {
    chartId: {
      type: String,
      required: true
    },
    series: {
      type: Array,
      default: function () {
        return []
      }
    },
    height: {
      type: String,
      default: '350'
    },
    colors:{
        type: Array,
        default: function () {
            return ['#1f82c4','#6ec6f5']
        }
    }
  },
  data() {
    return {
      chartOptions: {
        colors: this.colors,
        chart: {
          id:this.chartId,
          type: 'bar',
          stacked: true,
          toolbar: {
            show: true
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }],
        plotOptions: {
          bar: {
            columnWidth: '30%',
            borderRadius: 8,
            horizontal: false,
          },
        },
        grid:{
          show:false
        },
        xaxis: {
          categories: ['Products'
          ]
        },
        yaxis: {
          show: false
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        }
      }
    }
  },
  methods: {
    emitClickSection(event, chartContext, config){
      this.$emit('clickStackedSection',config)
    }
  }
}
</script>